export const CanaisAtendimentoTabs = {
  'whatsapp-santander': {
    id: 0,
    // href: '/whatsapp-santander',
    label: 'WhatsApp',
    // navigate: true,
    t: '',
  },
  'area-do-cliente': {
    id: 1,
    // href: '/area-do-cliente',
    label: 'Área do Cliente',
    // navigate: true,
    t: '',
  },
  'central-financiamentos': {
    id: 2,
    // href: '/contato',
    label: 'Central de Atendimento',
    // navigate: true,
    t: '',
  },
  // 'central-emprestimos': {
  //   id: 3,
  //   // href: '/contato',
  //   label: 'Central Empréstimos',
  //   // navigate: true,
  //   t: '',
  // },
};
